// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"0ed3a1fc","604":"8d8d68aa","856":"e7db8860","905":"eb760471","928":"684d3be6"}[chunkId] + ".chunk.js";
};